import { generateMockId } from '@gp/utils/common';
import { BoolFlag } from '@gp/enums/common';

import type { IDPSReportOtherOrMiscellaneousVO } from '@gp/types/dpsReport/v2';

export const CARD_TITLE = 'Other/Miscellaneous';

export const buildRecord = (): IDPSReportOtherOrMiscellaneousVO => ({
  mock_id: generateMockId(),
  is_custom: BoolFlag.False,
  project_id: '',
  project: '',
  platform: [],
  image_name: '',
  priority: '',
  cover: '',
  action_item: '',
});
